export const blockIconsAndroidCameraswitchNew = (
	<span className='material-symbols-outlined'>cameraswitch</span>
);
